document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.product-grid--scroll');
    var left = wrap.querySelector('.carousel-arrow--left');
    var right = wrap.querySelector('.carousel-arrow--right');
    if (!track || !left || !right) return;
    var scrollAmount = 280;
    left.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    right.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
});